(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function addStars(root) {
    root.querySelectorAll('[id$="__sc_hero"]').forEach((hero) => {
      if (hero.querySelector('.sc-stars')) return;
      const layer = document.createElement('div');
      layer.className = 'sc-stars';
      layer.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 22; i++) {
        const star = document.createElement('span');
        star.className = i % 4 === 0 ? 'sc-star sc-star--gold' : 'sc-star';
        star.style.left = `${Math.random() * 100}%`;
        star.style.top = `${Math.random() * 90}%`;
        star.style.setProperty('--sc-star-size', `${8 + Math.random() * 18}px`);
        star.style.setProperty('--sc-star-delay', `${(Math.random() * 4).toFixed(2)}s`);
        star.style.setProperty('--sc-star-duration', `${(2.2 + Math.random() * 2.6).toFixed(2)}s`);
        layer.appendChild(star);
      }
      hero.appendChild(layer);
    });
  }

  let observer;

  function addReveal(root) {
    if (reducedMotion || !('IntersectionObserver' in window)) return;
    observer ??= new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('sc-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    root.querySelectorAll('main .shopify-section').forEach((section, index) => {
      if (index === 0 || section.classList.contains('sc-reveal')) return;
      section.querySelectorAll('product-card').forEach((card, i) => card.style.setProperty('--sc-i', i % 4));
      section.classList.add('sc-reveal');
      observer.observe(section);
    });
  }

  function initVideoBanners(root) {
    root.querySelectorAll('.sc-vbanner').forEach((banner) => {
      if (banner.dataset.scReady) return;
      banner.dataset.scReady = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      let visible = true;
      const update = () => {
        const wanted = mobile.matches ? 'mobile' : 'desktop';
        banner.querySelectorAll('video[data-sc-src]').forEach((video) => {
          if (video.dataset.scVariant !== wanted || !visible || reducedMotion) {
            video.pause();
            return;
          }
          if (!video.getAttribute('src')) video.src = video.dataset.scSrc;
          video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
          video.play().catch(() => {});
        });
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          visible = entries[0].isIntersecting;
          update();
        }).observe(banner);
      }
      mobile.addEventListener('change', update);
      update();
    });
  }

  function init(root = document) {
    addStars(root);
    addReveal(root);
    initVideoBanners(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    section.classList.add('sc-in');
    init(document);
  });
})();
